<template>
  <div class="container">
    <div :id="mapContainerId" style="height: 33vh; z-index: 0"></div>
    <div class="search-form">
      <el-select
        class="search-form__left"
        v-model="addressId"
        remote
        filterable
        :placeholder="$t('components.locatePlaceholder')"
        @change="addressChangeHandler"
        :remote-method="searchPlace"
      >
        <el-option v-for="item in addresses" :key="item.key" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <span class="search-form__right">
         <base-icon
          iconClass="sight"
          className="marker"
          size="24px"
        ></base-icon>
      </span>
    </div>

    <div class="mapContainer-position">
      <div class="mapContainer-position__box">
        <span class="mapContainer-position__box__left">{{$t('common.latitude')}}</span>
        <el-input-number v-model="lat" controls-position="right" :max="90" :min="-90" placeholder="请输入数值"></el-input-number>
      </div>
      <div class="mapContainer-position__box">
        <span class="mapContainer-position__box__left">{{$t('common.longitude')}}</span>
        <el-input-number v-model="lng" controls-position="right" :max="180" :min="-180" placeholder="请输入数值"></el-input-number>
      </div>
    </div>
  </div>
</template>

<script>
import MapService from '@/services/map';

export default {
  props: {
    location: {
      // 可能为null
      type: Object,
      required: true,
    },
  },
  data() {
    const mapContainerId = `map-container-${Date.now()}`;
    const lat = (this.location && this.location.lat) || 39.56;
    const lng = (this.location && this.location.lng) || 116.20;
    return {
      mapContainerId,
      mapService: new MapService(mapContainerId, { showControl: false }),
      locationMarker: null, // 唯一标注
      addresses: [], // 保存地址备选项
      addressId: '',
      lat,
      lng,
    };
  },
  created() {
  },
  mounted() {
    let { lng, lat } = this.location;
    lng = lng || 39.56;
    lat = lat || 116.20;
    this.mapService.initMap(() => {
      // 初始化唯一标注
      this.locationMarker = this.mapService.addSimpleMarker({
        lat,
        lng,
        color: 'green',
        id: 'LocationMarker',
        name: this.$t('components.markedHere'),
        icon: 'greenPoint',
      });
      this.mapService.addListenerToMap('click', this.handleClick.bind(this));
    });
  },
  watch: {
    lat() {
      this.emitChange();
    },
    lng() {
      this.emitChange();
    },
    location({ lat, lng }) {
      // 把以前保存的可能不合法坐标格式化
      const validLat = Number.isNaN(+lat) ? 39.56 : +lat;
      const validLng = Number.isNaN(+lng) ? 116.20 : +lng;
      this.updateLocationMarker({ lat: validLat, lng: validLng });
    },
  },
  methods: {
    emitChange() {
      const { lat, lng } = this;
      this.$emit('change', { lat, lng });
    },
    handleClick(e) {
      const { lng, lat } = MapService.parseLngLatFromEvent(e);
      this.updateLocationMarker({ lng, lat });
    },

    // 根据输入搜索地址
    searchPlace(query) {
      if (query !== '') {
        this.mapService.placeSearch(query, (result) => {
          const { suggests } = result;
          if (!suggests) return;

          // 地址备选列表
          this.addresses = suggests.map((item) => {
            return {
              label: `${item.address} ${item.name}`,
              code: item.gbCode,
              key: `${item.address}${item.name}`,
              value: `${item.address}${item.name}`,
              address: `${item.address}${item.name}`,
            };
          });
        });
      } else {
        this.addresses = [];
      }
    },

    // 选中地址
    addressChangeHandler() {
      const address = this.addresses.find(item => item.value === this.addressId);
      if (address) {
        // 地址更新
        this.emitAddressChange(address.address);
        // 坐标更新
        this.mapService.getLocationPosition(address.address, (position) => {
          this.updateLocationMarker(position);
        });
      }
    },

    // 更新坐标位置，并触发事件
    updateLocationMarker(position) {
      if (!this.locationMarker) return;
      this.mapService.updateMarker({ id: 'LocationMarker', position });
      this.mapService.setCenter(position);
      this.emitLngLatChange(position);
    },

    // 触发经纬度更新事件
    emitLngLatChange({ lng, lat }) {
      this.lng = lng;
      this.lat = lat;
    },
    // 触发地址更新事件
    emitAddressChange(address) {
      this.$emit('address-change', address);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/theme/_themes.scss';
.container {
  position: relative;
  margin-bottom: 10px;
  /deep/ .el-input__inner {
    @include background_color('background-color-box2');
    border-radius: 0;
    @include font_color('font-black');
  }
  .search-form {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 200px;
    display: flex;
    &__left {
      @include background_color("background-color-box");
      /deep/ .el-input__inner {
        border: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
    &__right {
      display: inline-block;
      height: 100%;
      width: 42px;
      text-align: center;
      @include background_color('primary');
      @include font_color('font-white');
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .mapContainer-position {
    position: absolute;
    left: 5px;
    top: 5px;
  }
  .mapContainer-position__box {
    display: flex;
    margin-bottom: 8px;
    &__left {
      display: inline-block;
      height: 100%;
      width: 42px;
      text-align: center;
      @include background_color('primary');
      @include font_color('font-white');
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    /deep/ .el-input__inner {
      border-radius: 0;
      border:0px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    /deep/ .el-input-number__decrease,/deep/ .el-input-number__increase {
      border: 0px;
    }
  }
}
</style>
